import { combineReducers } from "redux"
import { chain } from "lodash"
import user from "./user"
import modules from "modules/reducer"
import global from "model/reducer"
import panelsReducer from "../new/connected-components/dashboard/store/panels-slice"
import modelReducer from "../new/connected-components/dashboard/store/model-slice"
import coreReducer from "../new/connected-components/dashboard/store/core-slice"
import tradeReducer from "../new/connected-components/dashboard/store/trade-slice"

const dashboard = combineReducers({
  panels: panelsReducer,
  model: modelReducer,
  core: coreReducer,
  trade: tradeReducer,
})

function getReducer(directory, paths) {
  return combineReducers(
    chain(paths.keys())
      .map(path => path.substr(2, path.length - 5))
      .map(path => [path, require(`${directory}/${path}.js`).default])
      .fromPairs()
      .value(),
  )
}

export default combineReducers({
  user,
  app: getReducer("./app", require.context("./app", false, /.js/)),
  modules,
  global,
  dashboard,
})
